import React from 'react';

import PageHeader from 'components/common/PageHeader';

import EmbeddedMimecastV2App from './EmbeddedMimecastV2App';

const MimecastV2App = () => (
  <>
    <PageHeader title="Mimecast (v2.0 API) input">
      <span>This input retrieves logs from version 2.0 of the Mimecast API.</span>
    </PageHeader>
    <EmbeddedMimecastV2App />
  </>
);

export default MimecastV2App;
